import { FC, memo } from 'react';
import NextImage from 'next/image';

import { ImageWrapper, OpenMapBtn, Map as UIMap, Image } from './map.styles';
import { MapProps } from './map.types';

export const Map: FC<MapProps> = memo(({ mapImageUrl, onClick }) => (
  <UIMap>
    <ImageWrapper>
      <Image
        src={mapImageUrl}
        alt="View map"
        objectFit="cover"
        layout="fill"
        priority
      />
      <OpenMapBtn onClick={() => onClick('open')}>
       VIEW MAP 
      </OpenMapBtn>
    </ImageWrapper>
  </UIMap>
));
